import styled from 'styled-components'
import { customTheme } from '../../../styles/theme'

export const Container = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const Image = styled.img`
  width: 80px;
  height: 80px;
`

export const Title = styled.h1`
  max-width: 549px;

  font-weight: bold;
  font-size: 36px;
  line-height: 54px;
  text-align: center;
  color: #FFFFFF;
`

export const Description = styled.div`
  max-width: 549px;

  font-size: 16px;
  line-height: 24px;
  text-align: center;
`

export const Form = styled.div`
  margin-top: 40px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    margin: 30px 0;
    width: 100%;
  }
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`

export const Label = styled.div`
  margin-bottom: 8px;

  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  color: #FFFFFF;
`

export const Textarea = styled.textarea`
  width: 310px;
  height: 97px;
  padding: 11px 8px;

  font-size: 14px;
  line-height: 21px;
  color: #333;
  background: #F2F2F2;
  border: 1px solid #828282;
  box-sizing: border-box;
  border-radius: 8px;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    width: 100%;
  }
`

export const Welcome = styled.div`
  margin-top: 2%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const WelcomeText = styled.h5`
  max-width: 549px;

  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
  color: #FFFFFF;
`

export const WelcomeDescription = styled.p` 
  max-width: 549px;
  
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #FFFFFF;
`
